import React, { Component } from 'react';

import { isMobile, isIOS } from 'react-device-detect';
import classes from './LocationStep.module.css';
import strings from '../../../../../assets/localization';
import Button from '../../../../UI/Button/Button';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import StepHeader from '../StepHeader/StepHeader';

export default class LocationStep extends Component {
  constructor(props) {
    super(props);
    this.autocomplete = React.createRef();
    this.state = {
      footer: 0,
    };
  }

  componentDidMount() {
    // console.log('STEP 2 DID MOUNT', this.autocomplete.refs.input.refs.input);
    if (!this._validateInput()) {
      this.autocomplete.focus();
    }

    document.addEventListener('keydown', this._handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this._handleKeyDown);
  }

  _handleKeyDown = (e) => {
    if (e.keyCode === 13 && this._validateInput()) {
      this.props.goToStep(3);
    }
  };

  _validateInput = () => {
    return this.props.location !== '';
  };

  _onFocus = () => {
    this.props.onFocus();
    this.setState({ footer: '1rem' });
  };

  _onBlur = () => {
    this.props.onBlur();
    this.setState({ footer: 0 });
  };

  render() {
    // console.log('STEP 2 RENDER:', this.props);
    const { hideHeader, isLandscape } = this.props;
    const autocompleteStyle = {
      minHeight: '15rem',
      marginTop: hideHeader ? '-1rem' : 0,
    };
    let cssStyles =
      hideHeader && isMobile && isIOS
        ? [classes.StepThree, classes.StepThreeSafari].join(' ')
        : classes.StepThree;
    let safariSafeHideHeader = isMobile && isIOS ? false : hideHeader;
    return (
      <div className={cssStyles}>
        <StepHeader
          hideHeader={!isLandscape && safariSafeHideHeader}
          headerText={strings.WhereAreYouLocated}
          subheaderText={strings.WellFindMatchesInYourArea}
          activeStep={2}
          pageCount={5}
        />
        <div className={classes.ContentWrapper}>
          <div className={classes.InputWrapper}>
            <div
              className={classes.AutocompleteWrapper}
              style={autocompleteStyle}
            >
              <Autocomplete
                setRef={(component) => {
                  this.autocomplete = component;
                }}
                onFocus={this._onFocus}
                onBlur={this._onBlur}
                setLocation={this.props.setLocation}
                searchLocation={this.props.searchLocation}
                nbsApiSearchLocation={this.props.nbsApiSearchLocation}
                location={this.props.location}
              />
            </div>
          </div>
          <div
            className={classes.Footer}
            style={{ marginBottom: this.state.footer }}
          >
            <Button
              width='98'
              disabled={!this._validateInput()}
              clicked={this.props.goToStep.bind(this, 3)}
            >
              {strings.next}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegister/Steps/LocationStep/LocationStep.js